import React from 'react';
import { Route } from 'react-router-dom';

import EBookReportEntityTablePlainPage from './EBookReportEntityTablePlainPage';
import EBookReportGroupTablePlainPage from './EBookReportGroupTablePlainPage';
import { PLAIN_WIDTH } from '../../components/plain/PlainPage';

import { getCurrentResource } from '../../util/tools'; 
import { performApiRequest, ENTITY_LOAD_PLAIN_API_URL } from '../../util/restapi'; 

const MODE_INIT = 'init';
const MODE_ERROR = 'error';
const MODE_ENTITY = 'entity';
const MODE_GROUP = 'group';


class EBookReportPlainPage extends React.Component {
	
	mode = '';
	
	constructor(props) {
		super(props);
		this.formTitle = 'Звіт розповсюджувача за програмою "єКнига"';
		this.plainResource = getCurrentResource().components.plain.PlainPage;
		this.errorMessage = '';
		
		this.state = {mode: MODE_INIT};
	}
	async componentDidMount() {
		document.title = 'BOM. ' + this.formTitle;
		let mode = '';
		let instanceId = this.props.match.params.id;
		if( instanceId.endsWith('-ro') ) {
			instanceId = instanceId.replace('-ro','');
		}
		if( instanceId == 0 )
			mode = MODE_GROUP;
		else {
			let response = await performApiRequest(ENTITY_LOAD_PLAIN_API_URL, {entityId: instanceId});
			if( response.success ) {
				let bean = response.data.entity;
				if( bean.reportItem == null )
					mode = MODE_ENTITY;
				else
					mode = MODE_GROUP;
			} else {
				this.errorMessage = response.message;
				mode = MODE_ERROR;
			}
		}
		this.setState({mode: mode})
	}
	
	render() {
		if( this.state.mode == MODE_INIT ) {
			return (
				<div style={{width: PLAIN_WIDTH, margin: 'auto', textAlign: 'left'}}>
					<div style={{marginTop: '15px', marginBottom: '10px', textAlign: 'left'}}>
						<span style={{marginRight: '15px', fontSize: '16pt', fontWeight: 'bold'}}>{this.formTitle}</span>
						<span style={{marginRight: '15px'}}>{this.plainResource.msgActivateForm}</span>
					</div>
				</div>
			);
		}
		if( this.state.mode == MODE_ERROR ) {
			return (
				<div style={{width: PLAIN_WIDTH, margin: 'auto', textAlign: 'left'}}>
					<div style={{marginTop: '15px', marginBottom: '10px', textAlign: 'left'}}>
						<span style={{marginRight: '15px', fontSize: '16pt', fontWeight: 'bold'}}>{this.formTitle}</span>
						<span style={{marginRight: '15px'}}>{this.errorMessage}</span>
					</div>
				</div>
			);
		}
		if( this.state.mode == MODE_GROUP ) {
			return (
				<Route {...this.props} render={props => <EBookReportGroupTablePlainPage {...this.props} /> } />
			);
		}
		if( this.state.mode == MODE_ENTITY ) {
			return (
				<Route {...this.props} render={props => <EBookReportEntityTablePlainPage {...this.props} /> } />
			);
		}
		return <div style={{textAlign: 'center', margin: '50px'}}>...</div>;
	}
}

export default EBookReportPlainPage;